<div class="footer-container">
  <div class="footer">
    <ng-content></ng-content>
  </div>
</div>
